import React, { useState, useEffect, useRef } from 'react';
import _ from 'lodash';
import { MultiSelect } from 'primereact/multiselect';
import { getControlField, getField } from '../../../../Services/tooltipService';
import { get, getTemplate, saveTemplate, UpdateWinPlanTemplate, getCustomerControlField } from '../../../../Services/customerServices';
import { InputIcon } from 'primereact/inputicon';
import { Dialog } from 'primereact/dialog';
import ButtonElement from '../../../../Components/UiComponents/ButtonElement';
import TextareaElement from '../../../../Components/UiComponents/TextareaElement';
import ToastElement from '../../../../Components/UiComponents/ToastElement';
import Loader from '../../../../Components/UiComponents/Loader';
import { useNavigate } from 'react-router-dom';
import PlaylistVideos from '../../../../Components/Videos/PlaylistVideos';

const ActivityPlanTemplate = () => {
	const [pipelineWinplanFields, setPipelineWinplanFields] = useState([]);
	const [winplanSections, setWinplanSections] = useState([]);
	const [referenceData, setReferenceData] = useState([]);
	const [groupData, setGroupData] = useState([]);
	const [planData, setPlanData] = useState([]);
	const [selectedModel, setSelectedModel] = useState([]);
	const [controlWinHeaders, setControlWinHeaders] = useState([]);
	const [controlWinTable, setControlWinTable] = useState('');
	const [controlWinPlan, setControlWinPlan] = useState('');
	const [planSections, setPlanSections] = useState([]);
	const [editWinPlan, setEditWinPlan] = useState(false);
	const [winPlanCategoryModal, setWinPlanCategoryModal] = useState(false);
	const [winPlanData, setWinPlanData] = useState({});
	const [loading, setLoading] = useState(false);
	const [displayName, setDisplayName] = useState([]);
	const [showVideo, setShowVideo] = useState(false);
	const navigate = useNavigate()
	const toastRef = useRef();

	const customerData = localStorage.getItem("enduser");
	if (customerData === null) {
		navigate("/login")
		localStorage.clear()
	}
	const customerDataInJSON = JSON.parse(customerData);

	const customerId = customerDataInJSON.customer;
	useEffect(() => {
		if (customerId) {
			getFields();
			getCustomerDetails();
			getControlFieldData();
			getCustomerFieldData();
		}
	}, [customerId]);

	useEffect(() => {
		if (winplanSections) {
			loadWinPlan()
		}
	}, [winplanSections])

	useEffect(() => {
		if (customerId && referenceData) {
			getTemplateData();
		}
	}, [customerId, referenceData]);

	useEffect(() => {
		if (groupData.length > 0 && planData.length > 0) {
			const matchedSelectedModel = matchSelectedModelWithGroupData(planData, groupData);
			setSelectedModel(matchedSelectedModel);
		}
	}, [planData, groupData])

	const getCustomerFieldData = async () => {
		try {
			if (customerId === null) {
				return;
			}
			const customerData = await getCustomerControlField(customerId);
			if (customerData && customerData.data) {
				let displayNames = [];
				customerData.data.cust[0].modules.forEach((item) => {
					displayNames.push({ label: item.display_name.toUpperCase(), tabs: item.tabs });
				});
				setDisplayName(displayNames)
			}
		} catch (error) {
			toastRef.current.showToast({
				type: 'error',
				message: 'An error occurred. Please try again or Contact Admin.'
			});
		}
	}

	const getFields = async () => {
		try {
			if (customerId === null) {
				return;
			}
			if (customerId != null) {
				const fieldsResponse = await getField(customerId);
				var projectModules = _.find(fieldsResponse?.data.cust[0].modules, { module_name: "Pipeline" }, true);
				var pipelineWinplanFields = _.find(projectModules.sub_modules, { sub_module_name: "Winplan" }).fields;
				setPipelineWinplanFields(pipelineWinplanFields);
			}
		} catch (error) {
			toastRef.current.showToast({
				type: 'error',
				message: 'An error occurred. Please try again or Contact Admin.'
			});
		}
	}

	const getCustomerDetails = async () => {
		try {
			if (customerId === null) {
				return;
			}
			var customerDataResponse = await get(customerId);
			var custData = customerDataResponse?.data?.reference_data;
			setReferenceData(custData)
			var option = _.find(custData, { option_names: "WinPlanSection" })
			if (option) {
				var winPlanSection = option.option_choice.filter(choice => choice.status === 'active');
				setWinplanSections(winPlanSection)
			}
		} catch (error) {
			toastRef.current.showToast({
				type: 'error',
				message: 'An error occurred. Please try again or Contact Admin.'
			});
		}
	}

	const getControlFieldData = async () => {
		try {
			if (customerId === null) {
				return;
			}
			var clientModuleData = await getControlField(customerId)
			var controlPanelModules = _.find(clientModuleData?.data?.cust[0].modules, { module_name: "Control Panel", status: true });
			var contlPannel_Winplan = _.find(controlPanelModules.tabs, { tab_name: "Activity Plan Template" }).display_name;
			setControlWinPlan(contlPannel_Winplan)
			var cntlPannel_Winplan = _.find(controlPanelModules.tabs, { tab_name: "Activity Plan Template" }).tables;
			setControlWinTable(cntlPannel_Winplan)
			var cntlPannelWinplanTemplateHeaders = _.find(cntlPannel_Winplan, { table_name: "Activity Plan Template" }).headers;
			setControlWinHeaders(cntlPannelWinplanTemplateHeaders)
		} catch (error) {
			toastRef.current.showToast({
				type: 'error',
				message: 'An error occurred. Please try again or Contact Admin.'
			});
		}
	}

	const getTemplateData = async () => {
		try {
			if (customerId === null) {
				return;
			}
			var templateData = await getTemplate(customerId)
			if (templateData && templateData.data) {
				var testSections = templateData.data.win_plan_section;
				setPlanSections(testSections)
				var selectedModel = [];
				for (var i = 0; i < testSections.length; i++) {
					var winThemes = referenceData.filter(item => item.display_name === testSections[i].win_plan_name);
					if (!_.isEmpty(winThemes)) {
						for (var j = 0; j < testSections[i].theme.length; j++) {
							testSections[i].theme[j].checked = false;
							var resLength = winThemes[0].option_choice.length;
							if (resLength > 0) {
								for (var m = 0; m < resLength; m++) {
									if (winThemes[0].option_choice[m].label == testSections[i].theme[j].win_plan_theme)
										selectedModel.push({ "label": winThemes[0].option_choice[m].label, "id": winThemes[0].option_choice[m]._id, "winplan": winThemes[0].display_name });
								}
							}
						}
					}
				}
				var modelNew = selectedModel.slice(0);
				setPlanData(modelNew)
			}
		} catch (error) {
			toastRef.current.showToast({
				type: 'error',
				message: 'An error occurred. Please try again or Contact Admin.'
			});
		}
	}

	const matchSelectedModelWithGroupData = (selectedModel, groupData) => {
		const matchedModel = selectedModel.map(selectedItem => {
			for (let group of groupData) {
				const foundItem = group.items.find(item => item.id === selectedItem.id);
				if (foundItem) {
					return foundItem;
				}
			}
			return null;
		}).filter(item => item !== null);
		return matchedModel;
	};

	const loadWinPlan = () => {
		var planLength = winplanSections.length;
		var newOptions = []
		for (var l = 0; l < planLength; l++) {
			var winThemes = referenceData.filter(item => item.display_name === winplanSections[l].label);
			if (winThemes.length > 0) {
				var resLength = winThemes[0].option_choice.length;
				if (resLength > 0) {
					for (var i = 0; i < resLength; i++) {
						newOptions.push({ "label": winThemes[0].option_choice[i].label, "id": winThemes[0].option_choice[i]._id, "winplan": winThemes[0].display_name });
					}
				}
			}
		}

		const groupedData = newOptions.reduce((acc, item) => {
			const group = acc.find(g => g.label === item.winplan);
			if (group) {
				group.items.push({ label: item.label, id: item.id });
			} else {
				acc.push({
					label: item.winplan,
					items: [{ label: item.label, id: item.id }]
				});
			}
			return acc;
		}, []);
		setGroupData(groupedData)
	}

	const winPlanLoad = (e) => {
		setSelectedModel(e.value)
		var addedItem = [];
		var deletedItem = [];
		if (e.value.length > planData.length) {
			addedItem = _.difference(e.value, planData);
			var theme = [];
			theme.push({
				win_plan_theme: e.selectedOption.label,
				theme_description: "",
				win_plan_user: []
			});
			var groupName = ''
			for (let data of groupData) {
				for (let i of data.items) {
					if (i.id == e.selectedOption.id) {
						groupName = data.label
					}
				}
			}
			if (_.isEmpty(planSections)) {
				planSections.push({
					win_plan_name: groupName,
					theme: theme,
				});
				planData.push(addedItem[0]);
			} else {
				const foundStrategy = planSections.filter(
					(item) => item.win_plan_name === groupName
				)[0];

				if (foundStrategy) {
					var index = _.findIndex(planSections, { win_plan_name: groupName, });
					planSections[index].theme.push({
						win_plan_theme: e.selectedOption.label,
						theme_description: "",
						win_plan_user: [],
					});
					planData.push(e.selectedOption);
				} else {
					planSections.push({
						win_plan_name: groupName,
						theme: theme,
					});
					planData.push(e.selectedOption);
				}
			}
		} else if (e.value.length < planData.length) {
			deletedItem = _.difference(planData, e.value);
			var groupName = ''
			for (let data of groupData) {
				for (let i of data.items) {
					if (i.id == e.selectedOption.id) {
						groupName = data.label
					}
				}
			}
			var planIndex = _.findIndex(planSections, { win_plan_name: groupName, });
			var themeIndex = _.findIndex(planSections[planIndex].theme, { win_plan_theme: e.selectedOption.label, });

			planSections[planIndex].theme.splice(themeIndex, 1);
			if (_.isEmpty(planSections[planIndex].theme)) {
				planSections.splice(planIndex, 1);
			}
			var index = _.findIndex(planData, { label: e.selectedOption.label, });
			planData.splice(index, 1);
		}
		setPlanData(planData)
	};

	const groupedItemTemplate = (option) => {
		return (
			<div className="flex align-items-center">
				<div>{option.label}</div>
			</div>
		);
	};

	const openWinPlan = (edit, section, data) => {
		var winPlanData = {};
		if (edit) {
			setEditWinPlan(true);
		} else {
			setEditWinPlan(false);
		}

		var status = ''
		if (data.isCompleted) {
			status = "Completed";
		} else {
			status = "Not Completed";
		}

		setWinPlanCategoryModal(true)
		if (data.win_plan_theme) {
			winPlanData = { section: section, theme: data.win_plan_theme, category: data.theme_description, action: data.planned_action, status: status };
			setWinPlanData(winPlanData);
		}
	}

	const saveWinplan = async () => {
		try {
			if (customerId === null) {
				return;
			}
			setLoading(true)
			var saveWinTemplate = await saveTemplate(customerId, planSections)
			if (saveWinTemplate && saveWinTemplate.data.success) {
				toastRef.current.showToast({
					type: 'success',
					message: controlWinPlan + " Updated Successfully"
				});
			} else {
				toastRef.current.showToast({
					type: 'error',
					message: "Error occured while updating template"
				});
			}
		} catch (error) {
			toastRef.current.showToast({
				type: 'error',
				message: 'An error occurred. Please try again or Contact Admin.'
			});
		} finally {
			setLoading(false)
		}
	}

	const closePopup = () => {
		setWinPlanCategoryModal(false)
	}

	const saveWinPlanTemplate = async () => {
		try {
			if (customerId === null) {
				return;
			}
			setLoading(true)
			var updatedData = await UpdateWinPlanTemplate(customerId, winPlanData.theme, winPlanData.section, winPlanData.category)
			if (updatedData && updatedData.data.success) {
				var label = _.find(pipelineWinplanFields, { field_name: "winPlan Section" }).display_name;
				toastRef.current.showToast({
					type: 'success',
					message: label + " updated"
				});
				setPlanSections((prevData) =>
					prevData.map((section) =>
						section.win_plan_name === winPlanData.section
							? {
								...section,
								theme: section.theme.map((theme) =>
									theme.win_plan_theme === winPlanData.theme
										? { ...theme, theme_description: winPlanData.category }
										: theme
								),
							}
							: section
					)
				);
				setWinPlanCategoryModal(false)
			} else {
				toastRef.current.showToast({
					type: 'error',
					message: updatedData.data.message
				});
			}
		} catch (error) {
			toastRef.current.showToast({
				type: 'error',
				message: 'An error occurred. Please try again or Contact Admin.'
			});
		} finally {
			setLoading(false)
		}
	}

	const renderFooter = () => {
		return (
			<div className="cancel-footer">
				<div className="align-center justify-end pb-0">
					{
						editWinPlan ?
							<>
								<ButtonElement label="Cancel" className="cancel-new-button" onClick={() => closePopup()} />
								<ButtonElement type="submit" label="Save" className="save-button" onClick={() => saveWinPlanTemplate()} />
							</>
							:
							<ButtonElement type="submit" label="Cancel" className="cancel-new-button" onClick={() => closePopup()} />
					}
				</div>
			</div>
		);
	};

	const handleButtonClick = () => {
        setShowVideo(true);
    };
    
    const closeVideo = () => {
        setShowVideo(false);
    };

	return (
		<div>
			<ToastElement ref={toastRef} />
			<Loader loading={loading} />
			<div className="form-group row align-items-center mb-0 mt-20 d-flex justify-content-between">
				<div className="col-md-4 pl-0">
					<p className="label-text">
						{displayName.length > 0 && _.find(displayName[0].tabs, { tab_name: "Activity Plan Template" })?.display_name + ' - ' + _.find(pipelineWinplanFields, { field_name: "winPlan Section" })?.display_name + 's'}
					</p>
				</div>
				<div className="col-md-12 text-right">
					<ButtonElement className="upload-button mt-2 mb-2" type="button" icon="pi pi-video" onClick={handleButtonClick}></ButtonElement>
				</div>
			</div>
			<div className="form-group row align-items-center mb-0 mt-10">
				<div className='col-md-8 pl-0 d-flex'>
					<div className="col-md-4 pl-0">
						<label className="form-label text-left">{_.find(pipelineWinplanFields, { field_name: "winPlan Section" })?.display_name}:</label>
					</div>
					<div className='col pr-0'>
						<MultiSelect
							value={selectedModel}
							options={groupData}
							onChange={(e) => winPlanLoad(e)}
							optionLabel="label"
							optionGroupLabel="label"
							optionGroupChildren="items"
							optionGroupTemplate={groupedItemTemplate}
							placeholder="Select"
							display="chip"
							className="w-full"
							maxSelectedLabels={1}
							showSelectAll={false}
						/>
					</div>
				</div>
			</div>
			<div className="group-table-data mt-10">
				<table className="group-datatable activity-template">
					<thead className="group-table-header">
						<tr>
							<th colSpan={4}>{_.find(controlWinTable, { table_name: 'Activity Plan Template' })?.display_name}</th>
						</tr>
						<tr>
							<th className="width-10">{_.find(controlWinHeaders, { header_name: 'Section' })?.display_name}</th>
							<th className="w-40">{_.find(controlWinHeaders, { header_name: 'Theme' })?.display_name}</th>
							<th className="w-40">{_.find(controlWinHeaders, { header_name: 'Background' })?.display_name}</th>
							<th>{_.find(controlWinHeaders, { header_name: 'View / Edit' })?.display_name}</th>
						</tr>
					</thead>
					<tbody className="group-table-row">
						{
							planSections && planSections.length > 0 && planSections.map((subscription, index) => {
								return (
									<React.Fragment key={index}>
										<tr>
											<td colSpan={5}>
												<label className="form-label text-left font-bold">{subscription.win_plan_name}</label>
											</td>
										</tr>
										{
											subscription.theme.length > 0 && subscription.theme.map((sub, ind) => {
												return (
													sub.showRec != false && (
														<tr>
															<td className='width-10'>
																&nbsp;
															</td>
															<td className='w-40'>
																<label className="form-label text-left">{sub.win_plan_theme}</label>
															</td>
															<td className='w-40'>
																<label className="form-label text-left">{sub.theme_description}</label>
															</td>
															<td>
																<InputIcon
																	className="pi pi-eye ml-0"
																	onClick={() => openWinPlan(false, subscription.win_plan_name, sub)}
																/>
																<InputIcon
																	className="pi pi-pencil ml-10"
																	onClick={() => openWinPlan(true, subscription.win_plan_name, sub)}
																/>
															</td>
														</tr>
													)
												)
											})
										}
									</React.Fragment>
								)
							})
						}
					</tbody>
				</table>
			</div>
			<div className="cancel-footer mt-20">
				<div className='d-flex align-center justify-end pb-0'>
					<ButtonElement className="save-button" type="submit" label="Save" onClick={saveWinplan} />
				</div>
			</div>
			<Dialog
				header={_.find(pipelineWinplanFields, { field_name: "winPlan Section" })?.display_name + ' Template: ' + winPlanData.section + ' - ' + _.find(pipelineWinplanFields, { field_name: "winPlan Section" })?.display_name + ' Themes '}
				visible={winPlanCategoryModal}
				position="right"
				onHide={() => closePopup()}
				draggable={false}
				resizable={false}
				footer={renderFooter()}
				className="table-dialog width-32"
			>
				<div>
					<div className="form-group row align-items-center mb-0 mt-0">
						<div className="col-md-4 pl-0">
							<label className="form-label text-left font-bold">
								{'Plan Section ' + _.find(controlWinHeaders, { header_name: "Theme" })?.display_name}:
							</label>
						</div>
						<div className="col pr-0">
							<label className="form-label text-left">{winPlanData.theme}</label>
						</div>
					</div>
					<div className="form-group row align-items-center mb-0 mt-0">
						<div className="col-md-4 pl-0">
							<label className="form-label text-left font-bold">
								{_.find(controlWinHeaders, { header_name: "Background" })?.display_name}:
							</label>
						</div>
						<div className="col pr-0">
							{
								editWinPlan ?
									<TextareaElement
										placeholder="Text"
										name="winplan_category"
										className="w-full"
										value={winPlanData.category}
										onChange={(e) => setWinPlanData((prevState) => ({
											...prevState,
											category: e.target.value
										}))}
										rows={3}
									/> :
									<label className="form-label text-left">
										{winPlanData.category}
									</label>
							}

						</div>
					</div>
				</div>
			</Dialog>

			<Dialog id="videoModal" visible={showVideo}
				breakpoints={{
				'1200px': '80vw',    // Larger modal on bigger screens
				'1024px': '85vw',    // Slightly smaller for medium screens
				'769': '90vw',     // Responsive on tablets
				'641px': '95vw',     // Almost full-width on mobile
				}}
				modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
			>
				<div className="video-overlay">
					<div className="video-container">
						<PlaylistVideos playlistId={process.env.REACT_APP_CONTROL_PANEL_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="control_panel_activity_plan" />
					</div>
				</div>
			</Dialog>
		</div>
	)
}

export default ActivityPlanTemplate